module.exports = __webpack_public_path__ + "static/media/octopus-tree.6c532bd8.gif";